import { createGlobalStyle } from "styled-components";

/** App-local body paint; design-system GlobalStyle still owns base resets. */
export const BusinessEngineSurface = createGlobalStyle`
  body {
    background: #f4f6f3;
    color: #18211d;
  }
  button {
    font: inherit;
  }
`;
